__turbopack_context__.v({
  "home-content": "home-content-module-scss-module__cXi-FG__home-content",
});
